import React, { useState } from 'react';
import { Numberbox } from 'ui';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { SavedReportsEndpoints } from 'app/area/shared/saved-reports/constants';
import { SavedReportValidation } from 'app/area/shared/saved-reports/types-store';

import { CompanyReportAdminTranslation } from '../../constants';
import { SavedReportCompanyReport } from '../types-store';

interface SavedReportFormProps {
  valueItem: ComplexValue<number>;

  updateCurrent: (savedReport: Partial<SavedReportCompanyReport>) => void;

  endpoints: SavedReportsEndpoints;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  locale: string;
  validation: SavedReportValidation<SavedReportCompanyReport>;
  translation: CompanyReportAdminTranslation;
}

const savedReportId = 'savedReportId';

export const SavedReportPicker: React.FC<SavedReportFormProps> = ({ valueItem, updateCurrent, locale, validation, translation }) => {

  const [mySavedReport, setMySavedReport] = useState(false);

  const onSavedReportIdChange = (value: number) => {
    setMySavedReport(false);
    updateCurrent(value ? { code: { value } } : { code: undefined });
  };

  const reportIdComponent = <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId={savedReportId}
      label={translation ? { text: translation.saved_report_id, required: true, visible: true } : undefined}
      value={!mySavedReport ? valueItem?.value : undefined}
      onChange={onSavedReportIdChange}
      useThousand=" "
      locale={locale}
      validation={!mySavedReport ? validation?.code : undefined}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;

  return <div className="row">{reportIdComponent}</div>;
};
